export default "__VITE_ASSET__ZA9fajJh__"